export default __webpack_public_path__ + "2a8370c46269c5cbaf2a83cec570102c.png";